import axios from "axios";

export default {
  namespaced: true,
  state: {
    languages: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    languagesMessage: ''
  },
  mutations: {
    RECEIVED_LANGUAGES(state, payload) {
      state.languages = payload;
      state.isReceiving = false;
    },
    RECEIVING_LANGUAGES(state) {
      state.isReceiving = true;
    },
    RECEIVED_LANGUAGE(state, payload) {
      console.log("RECEIVED LANGUAGE", payload);
      state = Object.assign(state, {
        languages: [...state.languages, payload],
        isReceiving: false,
      })
    },
    RECEIVING_LANGUAGE(state) {
      state.isReceiving = true;
    },
    UPDATED_LANGUAGE(state, payload) {
      console.log(state.languages);
      console.log(payload);
      let index = state.languages.findIndex(language => language._id === payload._id);
      state = Object.assign(state, {
        languages: state.languages.map((language, i) => {
          if (i === index) {
            return Object.assign({}, language, payload);
          }
          return language;
        }),
        isUpdating: false,
        languagesMessage: 'Languages has been updating!',
      })
    },
    UPDATING_LANGUAGE(state) {
      state.isUpdating = true;
    },
    DELETED_LANGUAGE(state, payload) {
      let indexToDelete = state.languages.findIndex(language => language._id === payload._id);
      console.log(indexToDelete);
      let languages = [...state.languages];
      languages.splice(indexToDelete, 1);
      state = Object.assign(state, {
        languages: [...languages],
        isDeleting: false,
        idToDelete: null,
        languagesMessage: 'Language has been Deleted!',
      });
    },
    DELETING_LANGUAGE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getLanguagesRequest({dispatch}) {
      dispatch("receivingLanguages");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/languages';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        dispatch("receiveLanguages", res.data);
      })
    },
    async updateLanguageListRequest({dispatch}, payload) {
      try{
        dispatch("receivingLanguage");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/languagelist/' + payload.languagelistid;
        let response = await axios({method: "put", url: url, headers: headers, data: payload});
        dispatch("receiveLanguage", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateLanguageRequest({dispatch}, payload) {
      dispatch("updatingLanguage");
      let id = payload._id;
      delete payload['_id'];
      console.log(id, payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/language/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (res) {
        console.log(res);
        dispatch("updateLanguage", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async deleteLanguageListRequest({dispatch}, payload) {
      try{
        dispatch("deletingLanguage", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/languagelist/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteLanguage", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertLanguageListRequest({dispatch}, payload) {
      try{
        dispatch("receivingLanguage");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/languagelist/' + payload.languageid;
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateLanguageImageRequest({dispatch}, payload) {
      dispatch("updatingLanguage");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.accountxc.com:3100/update/language/image/' + id;
      data = new FormData();
      data.append('image', payload.languageimage, payload.imagename); 
      delete payload['languageimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updateLanguage", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async createLanguageRequest({dispatch}, payload) {
      dispatch("receivingLanguages");
      let url;
      let data;
      let headers;
      let token = localStorage.getItem('token');
      
      if(payload.languageimage !== undefined) {
        headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        url = 'https://api.accountxc.com:3100/insert/language/withimage';
        data = new FormData();
        data.append('image', payload.languageimage, payload.imagename); 
        delete payload['languageimage'];
        for (let x in payload) { data.append(x, payload[x]) }
        console.log(data)
      } 
      else {
        headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
        url = 'https://api.accountxc.com:3100/insert/language';
        data = payload;
      }
      console.log(data)
      console.log(url)
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("receiveLanguage", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteLanguageRequest({dispatch}, payload) {
      dispatch("deletingLanguage", payload);
      console.log(payload);
      axios.get('https://api.accountxc.com:3100/delete/language/' + payload._id).then(() => {
        dispatch("deleteLanguage", {_id: payload._id});
      })
    },
    receiveLanguages({commit}, payload) {
      commit("RECEIVED_LANGUAGES", payload)
    },
    receivingLanguages({commit}) {
      commit("RECEIVING_LANGUAGES")
    },
    receiveLanguage({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_LANGUAGE", payload)
    },
    receivingLanguage({commit}) {
      commit("RECEIVING_LANGUAGE")
    },
    updateLanguage({commit}, payload) {
      commit("UPDATED_LANGUAGE", payload)
    },
    updatingLanguage({commit}) {
      commit("UPDATING_LANGUAGE")
    },
    deleteLanguage({commit}, payload) {
      commit("DELETED_LANGUAGE", payload)
    },
    deletingLanguage({commit}, payload) {
      commit("DELETING_LANGUAGE", payload)
    }
  },
};
